module.exports = __webpack_public_path__ + "static/media/squeeze.46763020.png";